import React from "react";
export default function Cookies() {
  return (
    <div data-testid="cookies-page" className="bg-[#F5EFE4] min-h-[80vh]">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10 pt-32 pb-20">
        <p className="overline">Legal</p>
        <h1 className="font-serif text-5xl mt-4 text-[#1A1815]">Cookie Policy</h1>
        <p className="text-sm text-[#6B665E] mt-2">Last updated: December 2025</p>
        <div className="mt-10 space-y-8 text-[#1A1815] leading-relaxed">
          <section><h2 className="font-serif text-2xl">What are cookies?</h2><p className="mt-3 text-[#4A453E]">Small text files stored on your device to make websites work and to collect usage information.</p></section>
          <section><h2 className="font-serif text-2xl">Categories we use</h2>
            <ul className="mt-3 text-[#4A453E] space-y-3 list-disc list-inside">
              <li><strong>Strictly necessary</strong> — Session/auth cookies used for sign-in and cart/booking flow. Cannot be disabled.</li>
              <li><strong>Functional</strong> — Remember your preferences (e.g. cookie choice).</li>
              <li><strong>Analytics</strong> — Anonymous usage stats to improve the site. Only set with your consent.</li>
              <li><strong>Marketing</strong> — Not set unless you consent.</li>
            </ul>
          </section>
          <section><h2 className="font-serif text-2xl">Third parties</h2><p className="mt-3 text-[#4A453E]">Stripe (payment processing), Cloudinary (media hosting). These providers may set their own cookies subject to their policies.</p></section>
          <section><h2 className="font-serif text-2xl">Your choice</h2><p className="mt-3 text-[#4A453E]">You can change or withdraw your cookie consent at any time via the banner on your next visit, or by clearing site data in your browser.</p></section>
        </div>
      </div>
    </div>
  );
}
